import { Paper, Skeleton } from '@mui/material';
import { HeaderSubTitle } from './headerSubTitle';
import { LargeCounter } from './largeCounter';

type StatBoxSmallProps = {
  isLoading: boolean;
  label: string;
  count: number;
};

export const StatBoxSmall = (props: StatBoxSmallProps) => {
  const { isLoading, label, count } = props;
  return (
    <Paper sx={{ p: 2 }}>
      <HeaderSubTitle label={label} />
      {isLoading ? <Skeleton variant='text' sx={{ fontSize: (theme) => theme.typography.h3 }} /> : <LargeCounter count={count} displaySuffix />}
    </Paper>
  );
};
